import React, { Component } from "react";

//components
import CustomDropdown from "../../../../../generic_components/components/dropdowns/CustomDropdown";
import RadioBtnHorizontal from "../../../../../generic_components/components/radio_btns/RadioBtnHorizontal";
import DatePickerBox from "../../../../../generic_components/components/input_boxes/DatePickerBox";
import TextBox from "../../../../../generic_components/components/input_boxes/TextBox";
import AutoCompleteTextBox from "../../../../../generic_components/components/input_boxes/AutoCompleteTextBox";
import LoadingPgTemplate from "../../../../../generic_components/view/LoadingPgTemplate";
import CariAppFormNavBtnBar from "../../../components/cari_app_form_components/CariAppFormNavBtnBar";
import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";
import CustomButton from "../../../../../generic_components/components/buttons/CustomButton";

//generic functions
import {
    isEmpty
} from "../../../../../functions/generic_functions";

import { 
    cari_app_form_pg_1_url, 
    cari_app_form_pg_2_url, 
    cari_app_form_pg_3_url, 
    cari_app_form_pg_4_url 
} from "../../../../../router/static_routes";

import { connect } from "react-redux";

//router
import {
    withRouter,
} from 'react-router-dom';

import {
    openCariModal,
    resetCariActiveData,
    setCariActiveUserData
} from "../../../../../redux/actions/indexActions";

//redux mapper
const mapStateToProps = state => {
    return {
        activeApplicationData: state.cariReducer.activeApplicationData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData
    };
};

const mapDispatchToProps = dispatch => {

    return {
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
        setCariActiveUserData: (user_data) => {
            dispatch(setCariActiveUserData(user_data))
        },
    };
};

/*
    props:
        pageLoaded => conditional rendering upon api load
        onChangeSetParentState => function to set parent state
        onChangeAddInstitution => function to add new institution
        customInstitutionCheckboxVal => true/false value of the custom institution
        postData => postData json, all post data for this page
        staticUiData => staticUiData json, all static loaded ui data for dropdowns, radio btns, etc 
        submitted => true/false to disabled the entire page
                hideFailedAppCreateModal => the function to hide the modal of failed app creation
        autoCompleteUrls {
            cari_api_university_auto_complete_url => url of university auto complete
            cari_api_country_auto_complete_url => url of country auto complete
        }
        autoCompleteParams {
            //auto complete parameters
        }
        today => today date
*/

class CariAppFormViewPg1 extends Component {
    constructor(Props) {
        super(Props);

        //refs
        this.toastRef = React.createRef();

        //helper functions
        this.getCariFormPgNum = this.getCariFormPageNum.bind(this);

        //handler for add applicant new insitution
        this.handleAddInstitution = this.handleAddInstitution.bind(this);
    }

    getCariFormPageNum() {
        var currentUrl = window.location.pathname;
        var current_cari_pg = null;
        //check which url it corresponds to
        if (currentUrl === cari_app_form_pg_1_url) {
            current_cari_pg = 1;
        }
        else if (currentUrl === cari_app_form_pg_2_url) {
            current_cari_pg = 2;
        }
        else if (currentUrl === cari_app_form_pg_3_url) {
            current_cari_pg = 3;
        }
        else if (currentUrl === cari_app_form_pg_4_url) {
            current_cari_pg = 4;
        }
        else {
            return undefined;
        }
        return current_cari_pg;
    }

    handleAddInstitution() {
        var customInstitutionObj = this.props.postData.customInstitutionObj;

        this.props.openCariModal({
            modalId: "addInstitutionModal",
            title: "Add Institution",
            contentText: "Please complete the following fields to add an institution.",
            customInstitutionData: customInstitutionObj,
            callBackFuncOnOk: (data) => {
                var newCustomInstitutionData = data;

                //api call to add new applicant institution, and it will do refresh of page
                if (!isEmpty(this.props.onAddInstitution)) {
                    this.props.onAddInstitution(newCustomInstitutionData, (institutionAdded, parentCallBackFunc) => {
                        // //only set if mounted
                        if (institutionAdded) {
                            this.toastRef.current.show({ life: 6000, severity: 'success', summary: "Successfully saved the new institution!", detail: "" });

                            //call back to refresh page
                            parentCallBackFunc();
                           
                        }
                        else {
                            //display toast
                            this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to save the new institution!', detail: "" });
                        }    
                    });
                }
               
            }
        });
    }

    render() {
        return (
            <div className="scene_element scene_element--fadeinright">
                {(!this.props.pageLoaded) ? 
                    <LoadingPgTemplate/>
                : null}

                <div className={(this.props.pageLoaded) ? "" : "display_none"}>
                    <br /><br /><br /><br/>

                    <div className="p-grid">
                        <div className="p-col-12 full-height">

                            <label className="cari_section_title_format">
                                Contact Information
                            </label>
                            
                            <div className="">
                                <br /> <br />

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Salutation
                                        </label>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <label className={"label_style"}>
                                            First Name <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <CustomDropdown
                                            value={this.props.postData['salutation']}
                                            options={this.props.staticUiData.salutationDropdownOptions}
                                            placeholder={"Select Salutation"}
                                            name={"salutation"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                        />
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <TextBox
                                            value={this.props.postData["first_name"]}
                                            name={"first_name"}
                                            placeholder={(this.props.submitted && this.props.postData["first_name"]=="")? "":"First Name"}
                                            required={true}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            maxLength={64}
                                            disabled={this.props.submitted}
                                            className={(this.props.submitted)? "disabled_input_box_format":"float_right_input_box_format"}
                                        />
                                    </div>
                                </div>

                                <br />

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Other Name
                                        </label>
                                    </div> 
                                    <div className="p-col-6 padding-left_style_col">
                                        <label className={"label_style"}>
                                            Last Name <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <TextBox
                                            value={this.props.postData["other_name"]}
                                            name={"other_name"}
                                            placeholder={(this.props.submitted && this.props.postData["other_name"]=="")? "":"Other Name"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            maxLength={64}
                                            disabled={this.props.submitted}
                                            className={(this.props.submitted)? "disabled_input_box_format":"input_box_format"}
                                        />
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <TextBox
                                            value={this.props.postData["last_name"]}
                                            name={(this.props.submitted && this.props.postData["last_name"]=="")? "":"last_name"}
                                            placeholder={"Last Name"}
                                            required={true}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            maxLength={64}
                                            disabled={this.props.submitted}
                                            className={(this.props.submitted)? "disabled_input_box_format":"float_right_input_box_format"}
                                        />
                                    </div>
                                </div> 

                                <br />

                                <div className="p-grid cari_radio_btn_form_padding">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Contact Preference
                                    </label>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <label className={"label_style"}>
                                            Phone Number <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">
                                    
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 radio_btn_padding_top">
                                        <RadioBtnHorizontal
                                            radioBtnOptions={this.props.staticUiData.contactPreferenceRadioOptions}
                                            name={"contact_pref"}
                                            value={this.props.postData["contact_pref"]}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                        />
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <TextBox
                                            value={this.props.postData['phone_number']}
                                            name={"phone_number"}
                                            placeholder={(this.props.submitted && this.props.postData["phone_number"]=="")? "":"(+___)___-___-____"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            required={true}
                                            maxLength={20}
                                            inputType={"tel"}
                                            disabled={this.props.submitted}
                                            className={(this.props.submitted)? "disabled_input_box_format":"float_right_input_box_format"}
                                        />
                                    </div>
                                </div>

                                {/* <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Gender
                                        </label>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <label className={"label_style"}>
                                            First Name <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                </div> */}

                                {/* <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <CustomDropdown
                                            value={this.props.postData['gender']}
                                            options={this.props.staticUiData.genderDropdownOptions}
                                            placeholder={"Select Gender"}
                                            name={"gender"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                        />
                                    </div>
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <span id="gender_disclaimer">
                                            <em>Response to this question is solely voluntary. Should you provide this data, your information will be anonymized for reporting purposes only.</em>
                                        </span>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col"></div>
                                </div> */}

                            </div>

                            <br/><br/><br/><br/>

                            <label className="cari_section_title_format">
                                Current Position
                            </label>
                            
                            <div className="">
                                <br /> <br />
                                 <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Do you currently hold a <strong>continuing</strong> faculty position at the Beedie School of Business? <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                </div>
                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <RadioBtnHorizontal
                                            value={this.props.postData['is_faculty']}
                                            radioBtnOptions={this.props.staticUiData.isFacultyDropdownOptions}
                                            name={"is_faculty"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                            required={true}
                                        />
                                    </div>
                                </div>
                                <br/><br/><br/><br/>
                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Position Title
                                        </label>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <label className={"label_style"}>
                                            Organization
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <TextBox
                                            value={this.props.postData["current_position_title"]}
                                            name={"current_position_title"}
                                            placeholder={(this.props.submitted && this.props.postData["current_position_title"]=="")? "":"Position Title"}
                                            required={false}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            maxLength={255}
                                            disabled={this.props.submitted}
                                            className={(this.props.submitted)? "disabled_input_box_format":"input_box_format"}
                                        />
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <TextBox
                                            value={this.props.postData["current_position_title"] == "" ? this.props.postData["current_position_organization"] = "" : this.props.postData["current_position_organization"]}
                                            name={"current_position_organization"}
                                            placeholder={(this.props.submitted && this.props.postData["current_position_organization"]=="")? "":"Organization"}
                                            required={false}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            maxLength={255}
                                            disabled={this.props.submitted || this.props.postData["current_position_title"] == ""}
                                            className={(this.props.submitted)? "disabled_input_box_format":"float_right_input_box_format"}
                                        />
                                    </div>
                                </div>

                                <br />

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Start Date
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <DatePickerBox
                                            className={""}
                                            numYearRangeBack={"60"}
                                            name={"current_position_start_date"}
                                            value={(this.props.postData["current_position_title"] == "" || this.props.postData["current_position_organization"] == "")? this.props.postData['current_position_start_date'] = "" : this.props.postData['current_position_start_date']}
                                            placeholder={(this.props.submitted && this.props.postData["current_position_start_date"]==null)? "":"Start Date"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted || (this.props.postData["current_position_title"] == "" || this.props.postData["current_position_organization"] == "")}
                                        />
                                    </div>
                                </div>
                            </div>

                            <br/><br/><br/><br/>

                            <label className="cari_section_title_format">
                                Highest Degree
                            </label>
                            
                            <div className="">
                                <br/><br/>

                                <div>
                                    <div className="p-grid">
                                        <div className="p-col-6 padding-right_style_col">
                                            <label className={"label_style"}>
                                                Institution <strong className="sfu_red">*</strong>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="p-grid">
                                        <div className="p-col-6 padding-right_style_col">
                                            <AutoCompleteTextBox
                                                value={this.props.postData["UniversityName"]}
                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                placeholder={(this.props.submitted && this.props.postData["UniversityName"]=="")? "":"Institution"}
                                                name={"UniversityName"}
                                                minLength={3}
                                                maxLength={100}
                                                autoCompleteUrl={this.props.autoCompleteUrls.cari_api_university_auto_complete_url}
                                                required={true}
                                                disabled={this.props.submitted}
                                                autoCompleteParams={this.props.autoCompleteParams}
                                            />
                                        </div>
                                    </div>  
                                </div>
                                <br/>

                                {(!this.props.submitted) ?
                                    <div className="p-grid cari_form_row_padding cari_form_checkbox_padding">
                                        <div className="p-col-12">
                                            {/* <CustomCheckBox
                                                name={"customInstitutionCheckboxVal"}
                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                checked={this.props.postData.customInstitutionCheckboxVal}
                                                label={"Check this box if you are unable to find an institution"}
                                                disabled={this.props.submitted}
                                            /> */}
                                            <CustomButton
                                                onClickSetParentState={(event) => this.handleAddInstitution()}
                                                name={"institution_modal"}
                                                disabled={this.props.submitted}
                                                btnRaised={true}
                                                textOnly={true}
                                                className={"add_institution_btn"}
                                                label={"Add an Institution Not Currently Listed"}
                                            />
                                        </div>
                                    </div>
                                : null}

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Degree <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <label className={"label_style"}>
                                            Degree Type <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <CustomDropdown
                                            value={this.props.postData['degree_type']}
                                            options={this.props.staticUiData.degreeTypeDropdownOptions}
                                            placeholder={"Select Degree Type"}
                                            name={"degree_type"}
                                            required={true}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                        />
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <TextBox
                                            value={this.props.postData['degree_name']}
                                            name={"degree_name"}
                                            placeholder={(this.props.submitted && this.props.postData["degree_name"]=="")? "":"Degree"}
                                            required={true}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            maxLength={200}
                                            disabled={this.props.submitted}
                                            className={(this.props.submitted)? "disabled_input_box_format":"float_right_input_box_format"}
                                        />
                                    </div>
                                </div>

                                <br/>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Level <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <label className={"label_style"}>
                                            Field of Study 
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <CustomDropdown
                                            value={this.props.postData['degree_level']}
                                            options={this.props.staticUiData.degreeLevelDropdownOptions}
                                            placeholder={"Select Degree Level"}
                                            name={"degree_level"}
                                            required={true}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                        />
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <TextBox
                                            value={this.props.postData['degree_field']}
                                            name={"degree_field"}
                                            placeholder={(this.props.submitted && this.props.postData["degree_field"]=="")? "":"Field of Study"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            maxLength={100}
                                            disabled={this.props.submitted}
                                            className={(this.props.submitted)? "disabled_input_box_format":"float_right_input_box_format"}
                                        />
                                    </div>
                                </div>

                                <br/>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Status <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <label className={"label_style"}>
                                            Start Date
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <CustomDropdown
                                            value={this.props.postData['degree_status']}
                                            options={this.props.staticUiData.degreeStatusDropdownOptions}
                                            name={"degree_status"}
                                            required={true}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                        />
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <DatePickerBox
                                            name={"start_date"}
                                            value={this.props.postData['start_date']}
                                            maxDate={this.props.today}
                                            numYearRangeBack={"60"}
                                            placeholder={(this.props.submitted && this.props.postData["start_date"]==null)? "":"Start Date"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                        />
                                    </div>
                                </div>

                                <br/>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className={"label_style"}>
                                            Completion or <br/> Expected Completion Date <strong className="sfu_red">*</strong>
                                        </label>
                                    </div>
                                </div>

                                <div className="p-grid">    
                                    <div className="p-col-6 padding-right_style_col">
                                        <DatePickerBox
                                            name={"end_date"}
                                            value={this.props.postData['end_date']}
                                            placeholder={(this.props.submitted && this.props.postData["end_date"]==null)? "":"Expected End Date"}
                                            minDate={this.props.postData['start_date']}
                                            numYearRangeBack={"60"}                                            
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            required={true}
                                            disabled={this.props.submitted}
                                        />
                                    </div>
                                </div>
                            </div>

                            <br/><br/><br/><br/>

                            {/* <label className="cari_section_title_format">
                                Citizenship
                            </label> */}
                            
                            <div className="">
                                <br/><br/>

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label>
                                            Please indicate your legal status to work in Canada (Ex. Canadian, Permanent Resident, Work Permit, etc.)
                                        </label>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        {/* <RadioBtnHorizontal
                                            radioBtnOptions={this.props.staticUiData.legallyWorksCanadaRadioOptions}
                                            name={"work_in_canada"}
                                            value={this.props.postData['work_in_canada']}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            disabled={this.props.submitted}
                                        /> */}
                                        <TextBox
                                            value={this.props.postData['citizenship_category']}
                                            name={"citizenship_category"}
                                            placeholder={(this.props.submitted && this.props.postData["citizenship_category"]=="")? "":"Legal Status to Work in Canada"}
                                            onChangeSetParentState={this.props.onChangeSetParentState}
                                            maxLength={200}
                                            disabled={this.props.submitted}
                                            className={(this.props.submitted)? "disabled_input_box_format":"float_right_input_box_format"}
                                        />
                                    </div>
                                </div>

                                {/* if selected yes, allow them to select a category
                                <div className={(!isEmpty(this.props.postData['work_in_canada'])
                                    && this.props.postData['work_in_canada'].toLowerCase() === "yes")
                                    ? "" : "display_none"}
                                >
                                    <div className="p-grid">
                                        <div className="p-col-6 padding-right_style_col">
                                            <label>
                                                If yes, please select the category <br/> which applies to you:
                                            </label>
                                        </div>

                                        <div className="p-col-6 padding-left_style_col">
                                            <CustomDropdown
                                                value={this.props.postData['citizenship_category']}
                                                options={this.props.staticUiData.workTypeDropdownOptions}
                                                placeholder={"Select Work Type"}
                                                name={"citizenship_category"}
                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                disabled={this.props.submitted}
                                            />
                                        </div>
                                    </div>

                                    <br/>

                                    if selected Canadian Work Permit or Canadian Study Permit , allow them to indicate the expiry date
                                    <div className={(!isEmpty(this.props.postData['citizenship_category']))
                                        && (this.props.postData['citizenship_category'].toLowerCase() === "canadian study permit"
                                            || this.props.postData['citizenship_category'].toLowerCase() === "canadian work permit")
                                        ? "" : "display_none"}
                                    >

                                        <div className="p-grid">
                                            <div className="p-col-6 padding-right_style_col">
                                                <label>
                                                    If you are in Canada on a work or <br/> study permit, please indicate the expiry date:
                                                </label>
                                            </div>
                                            <div className="p-col-6 padding-left_style_col">
                                                <DatePickerBox
                                                    name={"work_study_permit_expiry"}
                                                    value={this.props.postData['work_study_permit_expiry']}
                                                    placeholder={(this.props.submitted && this.props.postData["work_study_permit_expiry"]==null)? "":"Expiry Date"}
                                                    minDate={this.props.today}
                                                    onChangeSetParentState={this.props.onChangeSetParentState}
                                                    disabled={this.props.submitted}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div> */}

                            </div>
                        </div>
                    </div>

                    <div className="p-grid nav_btn_bar_padding">
                        <div className="p-col-12 scene_element scene_element--fadeinright">
                            <CariAppFormNavBtnBar 
                                page_num={this.getCariFormPageNum()} 
                                match={this.props.match}
                            />
                        </div>
                    </div>
                </div>

                <CariMainPgFooterView />
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormViewPg1));